import {
  VPC_CLEAR,
  VPC_ERROR,
  VPC_LOADED,
  VPC_SET_SAVE_STATE,
  VPC_DIRTY_CONFIGURATION,
  VPC_SET_SAVE_CODE,
  VPC_SET_SAVE_PROGRESS_STATUS,
} from '../actionConstants';
import { Vpc } from './vpcTypes';
import { Action } from '../../generalTypes';
import defaultState from './vpcDefaultState';
import views from '../../settings/views/views';

export default (state: Vpc = defaultState, action: Action<any>) => {
  switch (action.type) {
    case VPC_LOADED:
      return action.payload.currentView === views.PICKING_LIST
        ? {
            ...state,
            load: {
              ...state.load,
              code: action.payload.code,
            },
          }
        : state;

    case VPC_ERROR:
      return {
        ...state,
        vpcErrorList: [...state.vpcErrorList, 'error'],
      };

    case VPC_CLEAR:
      return defaultState;

    case VPC_SET_SAVE_STATE:
      return {
        ...state,
        save: {
          ...state.save,
          state: action.payload.state,
        },
      };

    case VPC_DIRTY_CONFIGURATION:
      return {
        ...state,
        save: {
          ...state.save,
          dirtyConfiguration: action.payload.dirtyConfiguration,
        },
      };

    case VPC_SET_SAVE_CODE:
      return {
        ...state,
        save: {
          ...state.save,
          code: action.payload.vpcCode,
        },
      };

    case VPC_SET_SAVE_PROGRESS_STATUS:
      return {
        ...state,
        save: {
          ...state.save,
          progressStatus: action.payload.progressStatus,
        },
      };

    default:
      return state;
  }
};
